import { usePlanningStore, VesselVisitRestowListPage } from '@tom-ui/planning'
import { PATHS, useAsyncFetch, withAuthenticationRequired } from '@tom-ui/utils'
import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useNavigate, useParams } from 'react-router'

export const VesselVisitRestowList = withAuthenticationRequired(
  observer(() => {
    const { id } = useParams()
    const navigate = useNavigate()

    const { vesselVisitQueryService, vesselVisitItemStore, orderItemStore, containerItemStore } =
      usePlanningStore()

    const vesselVisitId = Number(id)
    if (!vesselVisitId) {
      navigate(PATHS.visits.vesselVisits.url)
    }

    const vesselVisitItem = computed(() => vesselVisitItemStore.elements[vesselVisitId]).get()

    useAsyncFetch(async () => {
      await vesselVisitQueryService.fetchById(vesselVisitId)
      await orderItemStore.fetchByVisitId(vesselVisitId)
      await containerItemStore.fetchByVisitId(vesselVisitId)
    }, [vesselVisitId, vesselVisitQueryService, orderItemStore, containerItemStore])

    return <VesselVisitRestowListPage vesselVisitItem={vesselVisitItem} />
  }),
)
